import { Dispatch, SetStateAction, useEffect } from 'react';

import { Box, FormControlLabel, Grid, Radio, RadioGroup, Stack } from '@mui/material';
import { useField, useFormikContext } from 'formik';

interface RadioGroupFieldProp {
    options: { label: string; value: string }[];
    label?: string;
    name: string;
    containerGridSpacing?: number;
    labelGridSize?: number;
    radioGroupGridSize?: number;
    radioOptionGridSize?: number;
    setselectedvalue?: Dispatch<SetStateAction<string>>;
    defaultValue?: string;
    disabledOptions?: number[];
    props?: any;
}

export const RadioGroupField = ({
    options,
    label,
    containerGridSpacing = 3,
    labelGridSize = 3,
    radioGroupGridSize = 6,
    radioOptionGridSize = 4,
    setselectedvalue = (value: string) => value,
    disabledOptions = [],
    ...props
}: RadioGroupFieldProp) => {
    const [field, meta] = useField(props);

    useEffect(() => {
        setselectedvalue(field.value);
    }, [field.value]);

    return (
        <Stack>
            <Grid container spacing={containerGridSpacing}>
                <Grid item xs={labelGridSize}>
                    <Box className="mt-20">
                        <label className="font-bold">{label}</label>
                    </Box>
                </Grid>
                <Grid item xs={radioGroupGridSize} className="mt-10">
                    <RadioGroup data-testid={`${label}-radio-group`} {...field} {...props}>
                        <Grid container>
                            {options.map((option: any, index: number) => (
                                <Grid key={index} item xs={radioOptionGridSize}>
                                    <FormControlLabel
                                        disabled={!!disabledOptions[index]}
                                        key={index}
                                        value={option.value}
                                        control={<Radio />}
                                        label={option.label}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </RadioGroup>
                </Grid>
            </Grid>
            {meta.touched && meta.error && <label className="error">{meta.error}</label>}
        </Stack>
    );
};

export const RadioGroupBase = ({
    options,
    label,
    containerGridSpacing = 3,
    labelGridSize = 3,
    radioGroupGridSize = 6,
    radioOptionGridSize = 4,
    setselectedvalue = (value: string) => value,
    defaultValue,
    disabledOptions = [],
    ...props
}: RadioGroupFieldProp) => {
    const formik = useFormikContext();
    const handleChange = (e: any) => {
        e.preventDefault();
        setselectedvalue(e.target.value);
        formik.setFieldValue(props.name, e.target.value);
    };

    return (
        <Stack>
            <Grid container spacing={containerGridSpacing}>
                <Grid item xs={labelGridSize}>
                    <Box className="mt-20">
                        <label className="font-bold">{label}</label>
                    </Box>
                </Grid>
                <Grid item xs={radioGroupGridSize} className="mt-10">
                    <RadioGroup onChange={handleChange} defaultValue={defaultValue} {...props}>
                        <Grid container>
                            {options.map((option: any, index: number) => (
                                <Grid key={index} item xs={radioOptionGridSize}>
                                    <FormControlLabel
                                        disabled={!!disabledOptions[index]}
                                        key={index}
                                        value={option.value}
                                        control={<Radio />}
                                        label={option.label}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </RadioGroup>
                </Grid>
            </Grid>
        </Stack>
    );
};
